'use client';

import maps from 'src/data/maps.json';
import { ButtonAction, PageType } from 'src/analytics/EventProps';
import { trackLandingPageButtonClick } from 'src/analytics/Events';
import { Vertical } from 'src/constants/Verticals';
import { AdvancedAccordion } from '@get-mosh/msh-shared';

const { colors } = maps;

type SkinAccordionProps = {
    pageType: PageType;
};

function SkinAccordion({ pageType }: SkinAccordionProps) {
    return (
        <AdvancedAccordion
            initialOpenItem={0}
            activeColor={colors['grey-100']}
            items={[
                {
                    title: 'Not just for treating acne',
                    content:
                        '<p>The active ingredient in our prescription skincare is often considered to be a first line treatment when it comes to reducing fine lines and wrinkles.</p><br /><p>It encourages increased cell turnover help to improve fine lines and wrinkles and reduce irregular pigmentation, roughness and scaly skin to reveal smooth skin.</p>',
                },
                {
                    title: 'Stronger than store bought retinol',
                    content:
                        '<p>Most over-the-counter anti-ageing treatments include retinol, however the ingredient we include in your custom formula is much stronger. It\'s often considered to be the "magic ingredient" in the skincare world because of its ability to transform your skin</p>',
                },
                {
                    title: 'Backed by decades of scientific research',
                    content:
                        "<p>These treatments are backed by decades of scientific evidence and rigorous clinical trials to prove efficacy and ensure patient safety. Because of its strength it's only available via prescription so practitioners can work with patients on the best way to use and apply it</p>",
                },
            ]}
            onItemOpen={(item) => {
                trackLandingPageButtonClick({
                    button_action: ButtonAction.ACCORDION,
                    label: item.title,
                    page_type: pageType,
                    vertical: Vertical.SKIN,
                    location: 'Why prescription',
                });
            }}
        />
    );
}

export default SkinAccordion;
